var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ic-ajax-typeahead", {
    attrs: {
      id: _vm.id,
      url: _vm.url,
      text: _vm.stationName,
      getValue: _vm.getStationValue,
      getText: _vm.getStationText,
      onInputChange: _vm.onInputChange,
      minLength: 3,
      selectFirst: true,
      loading: _vm.loading,
      name: _vm.name,
    },
    on: {
      "update:text": function ($event) {
        _vm.stationName = $event
      },
      "update:item": function ($event) {
        _vm.station = $event
      },
      "is:loading": function ($event) {
        _vm.loading = $event
      },
    },
    model: {
      value: _vm.idHafas,
      callback: function ($$v) {
        _vm.idHafas = $$v
      },
      expression: "idHafas",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }